import { apiClient } from './client';

export interface User {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  role: 'admin' | 'teacher' | 'student' | 'parent';
  subject?: string;
  is_active: boolean;
  is_verified: boolean;
  date_joined: string;
  date_of_birth?: string;
}

export interface CreateUserData {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  role: 'teacher' | 'parent' | 'student' | 'admin';
  subject?: string;
  date_of_birth?: string;
}

export interface UpdateUserData {
  first_name?: string;
  last_name?: string;
  subject?: string;
  is_active?: boolean;
}

export const userApi = {
  list: async (role?: string): Promise<User[]> => {
    const params = role ? { role } : {};
    const response = await apiClient.get<User[] | { results: User[] }>('/auth/users/', { params });
    const data = response.data;
    return Array.isArray(data) ? data : (data as { results: User[] }).results;
  },

  get: async (id: string): Promise<User> => {
    const response = await apiClient.get<User>(`/auth/users/${id}/`);
    return response.data;
  },

  create: async (data: CreateUserData): Promise<User> => {
    const response = await apiClient.post<User>('/auth/users/', data);
    return response.data;
  },

  update: async (id: string, data: UpdateUserData): Promise<User> => {
    const response = await apiClient.patch<User>(`/auth/users/${id}/`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/auth/users/${id}/`);
  },

  getCounts: async (): Promise<{ teachers: number; students: number; parents: number }> => {
    const usersData = await userApi.list();

    return {
      teachers: usersData.filter(u => u.role === 'teacher').length,
      students: usersData.filter(u => u.role === 'student').length,
      parents: usersData.filter(u => u.role === 'parent').length,
    };
  },
};
